import type { MetaModelOutput } from '@festina/life-general-types/life'
import type { Optional } from '@festina-life/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useService } from '../../../hooks/useService'
import { useNavigationParams } from '../../../system/useNavigationParams'
import { fetchMetaModelKey } from '../keys'
import { transformMetaModel } from './helpers'
import { fetcher } from './useFetchMetaModel'

export const useLazyFetchMetaModel = () => {
  const { server, branch } = useNavigationParams()
  const service = useService(server, branch)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (layerId: string | null) => {
      const cachedMetaModel = queryClient.getQueryData(
        fetchMetaModelKey({
          server,
          branch,
          layerId,
        }),
      ) as Optional<MetaModelOutput>

      if (cachedMetaModel) {
        return transformMetaModel(cachedMetaModel)
      }

      const result = await fetcher({ layerId, service, server, branch })

      return transformMetaModel(result)
    },
  })
}
